<template>
	<div class="part palavra">
		<div v-html="part.PartEnunciado" class="enunciado">
		</div>
		<div class="conteudo">
		</div>
		<options-box 
		ref="optionsbox"
		:large="true"
		:part="part"></options-box>
	</div>
</template>

<style scoped>
.part.palavra div.conteudo {
	max-width: 500px;
}
</style>

<script>
import OptionsBox from '../OptionsBox'
import bus from '@/bus/event-bus.js'

export default {
	props: ['part', 'locked'],

	data() {
		return {
			partId: null,
			parsedConteudo: '',
			el: null,
			opcoes: []
		}
	},

	watch: {
		part() {
			if(this.part.PartId !== this.partId) {
				this.init()
			}
		}
	},

	mounted() {
		this.init()
	},

	methods: {

		init() {
			this.el = $(this.$el)
			this.setOpcoes()
			this.parseConteudo()
			this.fillBlanks()
			this.partId = this.part.PartId
		},

		respondeu(opcao, index) {
			var blank = this.getBlankByIndex(index + 1)

			if(opcao !== undefined) {
				blank.val(opcao.Id)
			}
		},

		parseConteudo() {

			this.parsedConteudo = this.part.PartConteudo.replace(/\{\((.+?)\)\}/g, (m, c) => {
				return this.makeSelect(c).prop('outerHTML')
			})

			this.el.find('.conteudo').html(this.parsedConteudo)
			var that = this

			this.el.find('[data-index]').change(function () {

				var id = $(this).val()

				if(id == '') return

				var index = parseInt($(this).attr('data-index'))
				var opcao = that.getOpcaoByOpcaoPartId(id)

				var pergunta = that.part.Perguntas[index - 1]
			
				if(opcao !== undefined) {
					pergunta.RespostaId = opcao.Id
					pergunta.Respondeu = true
					bus.$emit('respondeu', opcao.Id, pergunta.Id)
				} else {
					pergunta.RespostaId = id
					pergunta.Respondeu = true
					bus.$emit('respondeu', id, pergunta.Id)
				}

			});
		},

		makeSelect(index) {
			var select = $("<select></select>")
			select.attr('data-index', index)
			select.addClass('select embbedded pink')

			var defOption = $('<option></option>')
			defOption.text('-')
			defOption.attr('value', '')
			select.append(defOption)

			this.part.Opcoes.forEach((el) => {
				var option = $('<option></option>')
				option.attr('value', el.Id)
				option.text(el.Referencia)
				select.append(option)
			})

			return select
		},

		setOpcoes() {
			this.opcoes = this.part.Perguntas.map((el) => {
				return el.Opcoes[0]
			})
		},

		getOpcaoByReferencia(referencia) {
			return this.opcoes.find((el) => {
				return el.Referencia === referencia
			})
		},

		getOpcaoByOpcaoPartId(id) {
			var opcao = this.getOpcaoPartById(id)

			if(opcao !== undefined) {
				var opcaoPart = this.getOpcaoByReferencia(opcao.Referencia)
				return opcaoPart
			}

			return undefined
		},

		getOpcaoPartByReferencia(referencia) {
			return this.part.Opcoes.find((el) => {
				return el.Referencia === referencia
			})
		},

		getOpcaoPartById(id) {
			return this.part.Opcoes.find((el) => {
				return el.Id == id
			})
		},

		getOpcaoById(id) {
			return this.opcoes.find((el) => {
				return el.Id == id
			})
		},

		getOpcaoPartByOpcaoId(id) {
			var opcao = this.getOpcaoById(id)

			if(opcao !== undefined) {
				var opcaoPart = this.getOpcaoPartByReferencia(opcao.Referencia)
				return opcaoPart
			}

			return undefined
		},

		fillBlanks() {
			this.part.Perguntas.forEach((el, i) => {
				var opcao = this.getOpcaoPartByOpcaoId(el.RespostaId)

				if(opcao === undefined) {
					opcao = this.getOpcaoPartById(el.RespostaId)
				}

				this.respondeu(opcao, i)
			})
		},

		getBlankByIndex(index) {
			return this.el.find("[data-index='" + index + "']")
		}
	},

	components: {
		'options-box': OptionsBox
	}
}
</script>


// WEBPACK FOOTER //
// src/components/perguntas/lacuna-paragrafo/PerguntaLacunaParagrafo.vue